module.exports = __webpack_public_path__ + "static/media/team-sgr.8279669e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team-sgr.jpg
// module id = 296
// module chunks = 0